const ROUTES = {
  HOME: '/',
  AUTH: {
    ROOT: '/auth',
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    ERROR: '/auth/error',
  },
  POLICIES: '/policies',
  ADMIN: '/admin',
  USERPROFILE: '/profile',
  OPEN_ROUTES: [
    '/auth/login',
    '/auth/register',
    '/auth/error',
    '/policies',
  ] as string[],
  AI_TOOLS: {
    ROOT: '/ai-tools',
    DASHBOARD: '/ai-tools/dashboard',
    MY_DOCUMENTS: '/ai-tools/my-documents',
    LEGAL_FORMS: {
      CHOICE: '/ai-tools/legal-forms',
      FIND_FORM: '/ai-tools/legal-forms/find-form',
      LIBRARY: '/ai-tools/legal-forms/library',
    },
    FORMAL_NOTICE: '/ai-tools/formal-notice',
    CASE_LAW: '/ai-tools/caselaw',
    CASE_LAW_SEARCH: '/ai-tools/caselaw/search',
    PARCOURS: {
      ROOT: '/ai-tools/parcours',
      // LIST: '/ai-tools/parcours/list',
      CREATE: '/ai-tools/parcours/create',
      DETAIL: (id: string) => `/ai-tools/parcours/${id}`,
    },
  },
  MARKETPLACE: {
    ROOT: '/marketplace',
    CONVERSATIONS: '/marketplace/conversations',
    PROFILE: '/marketplace/profile',
    BILLING: '/marketplace/billing',
  },
  DASHBOARD: {
    ROOT: '/dashboard',
    CONVERSATIONS: '/dashboard/conversations',
    PROFILE: '/dashboard/profile',
    BILLING: '/dashboard/billing',
  },
} as const;

export default ROUTES;
